export default [
  {
    name: 'getNavigationList', // 导航栏
    method: 'GET',
    path: '/vue/kylin/getNavigationList'
  },
  {
    name: 'getWebContentList', // 获取网页展示内容
    method: 'GET',
    path: '/vue/kylin/getWebContentList'
  },
  {
    name: 'getHomePageSlideList', // 获取首页轮播图
    method: 'GET',
    path: '/vue/kylin/getHomePageSlideList'
  },
  {
    name: 'getSysbaseinfo', // 根据id加载系统基础信息表
    method: 'GET',
    path: '/vue/kylin/sysbaseinfo'
  },
  {
    name: 'getHomePageContent', // 获取首页内容
    method: 'GET',
    path: '/vue/kylin/getHomePageContent'
  }
];
